export enum SearchSelector {
  CreatedDate = 'createdDate',
  ReportDate = 'reportDate',
  ReportableDayStart = 'reportableDayStart',
  ReportableDayEnd = 'reportableDayEnd',
  CreatedDateFrom = 'createdDateFrom',
  CreatedDateTo = 'createdDateTo',
  ReportId = 'reportId',
  MerchantUuid = 'merchantUuid',
  EntityId = 'entityId',
}
